import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { CheckCircle2, Loader2, AlertCircle, Clock } from "lucide-react";

const MAP = {
  ready: { label: "Hazır", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  failed: { label: "Başarısız", cls: "bg-red-50 text-red-700 border-red-200", Icon: AlertCircle },
  uploaded: { label: "Sırada", cls: "bg-zinc-100 text-zinc-600 border-zinc-200", Icon: Clock },
  parsing: { label: "Ayrıştırılıyor", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Loader2 },
  chunking: { label: "Parçalanıyor", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Loader2 },
  embedding: { label: "Vektörleniyor", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Loader2 },
  indexing: { label: "İndeksleniyor", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Loader2 },
};

export default function StatusBadge({ status, testId }) {
  const s = MAP[status] || MAP.uploaded;
  const spin = ["parsing", "chunking", "embedding", "indexing"].includes(status);
  return (
    <Badge
      data-testid={testId}
      variant="outline"
      className={cn("gap-1.5 font-medium rounded-full px-2.5 py-0.5", s.cls)}
    >
      <s.Icon className={cn("h-3.5 w-3.5", spin && "animate-spin")} />
      {s.label}
    </Badge>
  );
}
